<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'integrations.webhookTestModal.title' | translate }}</h4>
      <button type="button" class="btn-close" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <div class="alert alert-info mb-3">
        <i class="mdi mdi-information-outline me-1"></i>
        {{ 'integrations.webhookTestModal.infoSendTestRequest' | translate }}
      </div>

      <form [formGroup]="formGroup">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <label class="form-label mb-0 fw-semibold">{{ 'integrations.webhookTestModal.requestFields' | translate }}</label>
          <button type="button" class="btn btn-primary" (click)="addField()">
            <i class="mdi mdi-plus me-1"></i>
            {{ 'integrations.webhookTestModal.addField' | translate }}
          </button>
        </div>

        @if (fieldsArray.length === 0) {
          <div class="alert alert-light text-center py-4">
            <i class="mdi mdi-information-outline d-block mb-2" style="font-size: 24px;"></i>
            <span class="text-muted">{{ 'integrations.webhookTestModal.noFieldsAdded' | translate }}</span>
          </div>
        } @else {
          <div class="fields-container">
            @for (field of fieldsArray.controls; track $index) {
              <div class="row g-2 mb-2 align-items-start" [formGroup]="getFieldGroup($index)">
                <div class="col-5">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="key"
                    [placeholder]="'integrations.webhookTestModal.placeholderKey' | translate"
                  />
                </div>
                <div class="col-5">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="value"
                    [placeholder]="'integrations.webhookTestModal.placeholderValue' | translate"
                  />
                </div>
                <div class="col-2">
                  <button
                    type="button"
                    class="btn btn-outline-danger btn-sm w-100"
                    (click)="removeField($index)"
                    [title]="'integrations.webhookTestModal.removeField' | translate"
                  >
                    <i class="mdi mdi-trash-can-outline"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()" [disabled]="isSending">{{ 'integrations.webhookTestModal.cancel' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="sendTest()" [disabled]="isSending">
        @if (isSending) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          {{ 'integrations.webhookTestModal.sending' | translate }}
        } @else {
          <i class="mdi mdi-send me-1"></i>
          {{ 'integrations.webhookTestModal.sendTest' | translate }}
        }
      </button>
    </div>

  </div>
</div>
